import type { AppState, Sticker } from "../app/state/AppState"
import type { StateStore } from "../app/state/StateStore"
import type {
  Task,
  GapTask,
  GapSegment
} from "../app/api/types"
import type { RepeatItem } from "../app/api/ApiClient"

type RenderDeps = {
  onCompleteClick: () => void
  onContinueClick: () => void
  onSubscribeClick: (stickerId: string, currency: "UAH") => void
  onPrevClick: () => void
  onNextClick: () => void
  onEntryClick: () => void

  onBackClick: () => void
  onOpenRepeatClick: () => void
  onToggleLesson: (lessonId: string) => void
  onOpenKrokFromRepeat: (krokId: string) => void
  onReturnToCurrentClick: () => void
  onListClick: () => void
  onOpenKrokFromList: (krokId: string) => void
  onUserClick: () => void
  
  onConfirmChangeClick: (stickerId: string) => void
  onFetchSubscriptions: (productId: string) => Promise<any>
  onConfirmSubscriptionChange: (stickerId: string) => Promise<any>
  onCancelSubscription: (subscriptionId: string) => Promise<any>

  // 🔥 ВОТ ЭТО ДОБАВИТЬ
  applyScreen: (screen: any) => void

  // AUTH
  onLogin: (email: string, password: string) => Promise<void>
  onConfirmOtp: (email: string, otp: string) => Promise<void>
  onResendOtp: (email: string) => Promise<void>
  onRegister: (email: string, password: string) => Promise<void>
  onRequestOtp: (email: string) => Promise<void>
  onLogout: () => void
}

export class RenderEngine {
  private root: HTMLElement
  private store: StateStore
  private deps: RenderDeps

   
  private lastKrokId: string | null = null
  private authMode: "login" | "register" = "register"

  private otpSubmitting = false

  constructor(
    root: HTMLElement,
    store: StateStore,
    deps: RenderDeps
  ) {
    this.root = root
    this.store = store
    this.deps = deps

    document.addEventListener("click", this.handleClick)
    
    document.addEventListener("input", this.handleOtpInput)
    document.addEventListener("keydown", this.handleOtpKeyDown)
    document.addEventListener("paste", this.handleOtpPaste)

    let saveTimeout: number | null = null
    document.addEventListener("input", (e) => {
        const el = e.target as HTMLElement
        if (!el.matches("[data-gap]")) return

        if (saveTimeout) {
          clearTimeout(saveTimeout)
        }

        saveTimeout = window.setTimeout(() => {
          this.saveGapInputsSilently()
        }, 300)
      })

    // =========================
    // SCROLL SAVE
    // =========================

    let scrollTimeout: number | null = null

    window.addEventListener("scroll", () => {

      if (scrollTimeout) {
        clearTimeout(scrollTimeout)
      }

      scrollTimeout = window.setTimeout(() => {

        const scrollY = window.scrollY

        const state = this.store.getState()

        // 🔥 сохраняем ТИХО (как gaps)
        localStorage.setItem(
          "supergerman_app_state_v2",
          JSON.stringify({
            currentKrokId: state.currentKrokId,
            gaps: state.gaps,
            revealed: state.revealed,
            scrollY
          })
        )

      }, 200)
    })
  

  }

    // =========================
    // EVENTS
    // =========================

    private handleClick = async (e: MouseEvent) => {

      const el = e.target instanceof Element ? e.target : null
      if (!el) return

      const actionEl = el.closest<HTMLElement>("[data-action]")
      if (!actionEl) return

      const action = actionEl.dataset.action
      if (!action) return

      // 🔥 form safety (ТОЛЬКО для submit-кнопок)
      if (actionEl.tagName === "BUTTON" && actionEl.closest("form")) {
        e.preventDefault()
      }

      const id = actionEl.dataset.id
      const currency = actionEl.dataset.currency as "UAH" | undefined
      const taskIndex = actionEl.dataset.taskIndex

      switch (action) {

        case "auth-submit":
          await this.handleAuthSubmit()
          return

      case "otp-submit":



          if (this.otpSubmitting) {
              return
          }

          this.otpSubmitting = true

          try {

              await this.handleOtpSubmit()

          } finally {

              this.otpSubmitting = false

          }

          return

        case "otp-resend":
          await this.handleOtpResend()
          return  

        case "register-submit":
          await this.handleRegisterSubmit()
          return

        case "login-submit":
          await this.handleLoginSubmit()
          return

        case "switch-login":
          this.authMode = "login"
          this.lastSnapshot = ""
          this.render(this.store.getState())
          return

        case "switch-register":
          this.authMode = "register"
          this.lastSnapshot = ""
          this.render(this.store.getState())
          return

        case "subscribe":
          if (id && currency) {
            this.deps.onSubscribeClick(id, currency)
          }
          return

        case "confirm-change":
          if (id) {
            this.deps.onConfirmChangeClick(id)
          }

          return  

        case "logout":
          this.deps.onLogout()
          return


        case "back":
          this.deps.onBackClick()
          return

        case "complete":
          await this.deps.onCompleteClick()
          return

        case "continue":
          this.deps.onContinueClick()
          return

        case "prev":
          this.deps.onPrevClick()
          return

        case "next":
          this.deps.onNextClick()
          return

        case "entry":
          this.deps.onEntryClick()
          return

        case "open-repeat":
          this.deps.onOpenRepeatClick()
          return

        case "toggle-lesson":
          if (id) this.deps.onToggleLesson(id)
          return

        case "open-krok":
          if (id) this.deps.onOpenKrokFromRepeat(id)
          return

        case "go-next-from-notice":

          if (id) {
            this.deps.onOpenKrokFromList(id)
          }

          return

        case "return-current":
          this.deps.onReturnToCurrentClick()
          return

        case "reveal":

          // 🔥 СНАЧАЛА собираем все значения
          this.collectGapInputs()

          if (taskIndex !== undefined) {
            this.toggleReveal(Number(taskIndex))
          }

          return

        case "list":
          this.deps.onListClick()
          return

        case "open-krok-from-list":
          if (id) this.deps.onOpenKrokFromList(id)
          return
        case "open-inline-krok":

            if (id) {
                this.deps.onOpenKrokFromList(id)
            }

            return

                case "user":
                  this.deps.onUserClick()
                  return

          case "open-landing": {

            const url =
              actionEl.dataset.url

            if (url) {

              window.open(
                url,
                "_blank"
              )

            }

            return
          }

          case "copy-landing-link": {

            const url =
              actionEl.dataset.url

            const title =
              actionEl.dataset.title

            if (!url) {
              return
            }

            try {

              await navigator.clipboard.writeText(
                `Курс: ${title}\n${url}`
              )

              alert(
                "Посилання скопійовано, вставте його і відправте у зручний вам спосіб (Telegram, Viber, e-mail тощо)"
              )

            } catch {

              alert(
                "Не вдалося скопіювати посилання"
              )

            }

            return
          }

                case "open-subscriptions": {

                const productId =
                  actionEl.dataset.productId

                try {

                  const res =
                    await this.deps.onFetchSubscriptions(
                      productId
                    )

                  this.deps.applyScreen(
                    res.screen
                  )

                } catch {

                  alert(
                    "Помилка завантаження підписок"
                  )

                }

                return
              }

                  case "confirm-subscription-change":

                    const state = this.store.getState()
                    const stickerId = state.selectedSticker

                    if (!stickerId) return

                    try {

                      const result = await this.deps.onConfirmSubscriptionChange(stickerId)

                      // 🔥 1. если backend вернул screen
                      if (result.screen) {
                        this.deps.applyScreen(result.screen)
                        return
                      }

                      // 🔥 2. если redirect (оплата)
                      if (result.redirect_url) {
                        window.location.href = result.redirect_url
                        return
                      }

                      throw new Error("Invalid subscribe response")

                    } catch (e) {

                      console.error("CONFIRM ERROR", e)
                      alert("Помилка підтвердження")

                    }

                    return


          case "cancel-subscription": {

            const subscriptionId =
              actionEl.dataset.subscriptionId ?? null

            this.store.update(prev => ({
              ...prev,

              selectedSubscriptionId:
                subscriptionId,

              primaryScreen: {
                type: "confirmCancelSubscription"
              }
            }))

            return
          }

            case "confirm-cancel-subscription": {

              const subscriptionId =
                this.store.getState()
                  .selectedSubscriptionId

                if (!subscriptionId) {
                  return
                }

                try {

                  const result =
                    await this.deps.onCancelSubscription(
                      subscriptionId
                    )

                  if (result?.type === "error") {
                    return
                  }

                  // 🔥 reload account screen
                  this.deps.onUserClick()

                } catch (e) {

                  console.error(e)

                }

                return
              }


      }
    }
    private async handleAuthSubmit() {

      const emailInput =
        this.root.querySelector("#auth-email") as HTMLInputElement

      const errorEl =
        this.root.querySelector("#auth-error") as HTMLElement

      if (!emailInput) return

      const email = emailInput.value.trim()

      if (!email) {
        if (errorEl) errorEl.textContent = "Введіть email"
        return
      }

      try {

        // 🔥 ВМЕСТО login → requestOtp
        await this.deps.onRequestOtp(email)

        // 🔥 ПЕРЕХОД В OTP ЭКРАН
        this.store.update(prev => ({
          ...prev,
          primaryScreen: {
            type: "otp",
            email
          }
        }))

      } catch {

        if (errorEl) errorEl.textContent = "Помилка відправки коду"

      }
    }

    private async handleRegisterSubmit() {
          const email =
            (this.root.querySelector("#register-email") as HTMLInputElement).value.trim()

          const password =
            (this.root.querySelector("#register-password") as HTMLInputElement).value.trim()

          const errorEl =
            this.root.querySelector("#register-error") as HTMLElement

          if (!email || !password) {
            if (errorEl) errorEl.textContent = "Заповніть всі поля"
            return
          }

          try {
            await this.deps.onRegister(email, password)
          } catch {
            if (errorEl) errorEl.textContent = "Помилка реєстрації"
          }
        }

    private async handleLoginSubmit() {
          const email =
            (this.root.querySelector("#login-email") as HTMLInputElement).value.trim()

          const password =
            (this.root.querySelector("#login-password") as HTMLInputElement).value.trim()

          const errorEl =
            this.root.querySelector("#login-error") as HTMLElement

          if (!email || !password) {
            if (errorEl) errorEl.textContent = "Заповніть всі поля"
            return
          }

          try {
            await this.deps.onLogin(email, password)
          } catch {
            if (errorEl) errorEl.textContent = "Помилка авторизації"
          }
        }

    private async handleOtpSubmit() {
      
      const inputs = Array.from(
        this.root.querySelectorAll<HTMLInputElement>(".otp")
      )

      const errorEl =
        this.root.querySelector("#otp-error") as HTMLElement

      const otp = inputs.map(i => i.value).join("")

      if (otp.length !== 4) {
        if (errorEl) errorEl.textContent = "Введіть 4 цифри"
        return
      }

      const state = this.store.getState()
      const email = (state.primaryScreen as any).email

      if (!email) {
        if (errorEl) errorEl.textContent = "Email не знайдено"
        return
      }

      try {

          const button =
    this.root.querySelector('[data-action="otp-submit"]') as HTMLButtonElement

      const resendButton =
          this.root.querySelector('#otp-resend-btn') as HTMLButtonElement

      if (errorEl) {
          errorEl.textContent = ""
      }

      if (button) {
          button.disabled = true
          button.textContent = "Перевіряємо..."
      }

      if (resendButton) {
          resendButton.disabled = true
      }

      inputs.forEach(i => i.disabled = true)
      // дать браузеру возможность перерисовать кнопку
          await new Promise(resolve => setTimeout(resolve, 0));

          await this.deps.onConfirmOtp(email, otp)

      } catch {

          if (errorEl) {
              errorEl.textContent = "Невірний код"
          }

          const button =
              this.root.querySelector('[data-action="otp-submit"]') as HTMLButtonElement

          if (button) {
                button.disabled = false
                button.textContent = "Підтвердити"
            }

            if (resendButton) {
                resendButton.disabled = false
            }

            inputs.forEach(i => i.disabled = false)

      } 


    } 

    private async handleOtpResend() {

        const state = this.store.getState()
        const email = (state.primaryScreen as any).email

        if (!email) return

        const btn = this.root.querySelector("#otp-resend-btn") as HTMLButtonElement

        try {

          await (this.deps as any).onResendOtp(email)

          // 🔥 блокируем кнопку
          if (btn) {
            btn.disabled = true
            btn.textContent = "Надіслано"
          }

          // 🔥 таймер 60 сек
          let seconds = 60

          const interval = setInterval(() => {
            seconds--

            if (btn) {
              btn.textContent = `Повторити через ${seconds}s`
            }

            if (seconds <= 0) {
              clearInterval(interval)
              if (btn) {
                btn.disabled = false
                btn.textContent = "Надіслати код ще раз"
              }
            }

          }, 1000)

        } catch (e: any) {

          if (e?.status === 429) {
            alert("Забагато спроб. Спробуйте пізніше")
            return
          }

          alert("Помилка повторної відправки")
        }
      }    



    // =========================
    // COLLECT ALL GAP INPUTS
    // =========================

    private collectGapInputs(): void {

      const inputs = this.root.querySelectorAll<HTMLInputElement>("[data-gap]")

      const updates: {
        [taskIndex: number]: {
          [segmentIndex: number]: string
        }
      } = {}

      inputs.forEach(input => {

        const taskIndex = Number(input.dataset.taskIndex)
        const segmentIndex = Number(input.dataset.segmentIndex)

        if (isNaN(taskIndex) || isNaN(segmentIndex)) return

        if (!updates[taskIndex]) {
          updates[taskIndex] = {}
        }

        updates[taskIndex][segmentIndex] = input.value
      })

      if (Object.keys(updates).length === 0) return

      this.store.update(prev => ({
        ...prev,
        gaps: {
          ...prev.gaps,
          ...updates
        }
      }))
    }

    // =========================
    // SILENT SAVE (NO RENDER)
    // =========================

    private saveGapInputsSilently(): void {

      const inputs = this.root.querySelectorAll<HTMLInputElement>("[data-gap]")

      const gaps: any = {}

      inputs.forEach(input => {

        const taskIndex = Number(input.dataset.taskIndex)
        const segmentIndex = Number(input.dataset.segmentIndex)

        if (isNaN(taskIndex) || isNaN(segmentIndex)) return

        if (!gaps[taskIndex]) {
          gaps[taskIndex] = {}
        }

        gaps[taskIndex][segmentIndex] = input.value
      })

      const state = this.store.getState()

      // 👉 сохраняем напрямую, без render
      localStorage.setItem(
        "supergerman_app_state_v2",
        JSON.stringify({
          currentKrokId: state.currentKrokId,
          gaps,
          revealed: state.revealed,
          scrollY: state.scrollY
        })
      )
    }


    private handleOtpInput = (e: Event) => {

      const input = e.target as HTMLInputElement
      if (!input.classList.contains("otp")) return

      const value = input.value.replace(/\D/g, "") // только цифры
      input.value = value

      const index = Number(input.dataset.i)

      const inputs = Array.from(
        this.root.querySelectorAll<HTMLInputElement>(".otp")
      )

      // 👉 если ввели цифру — идём дальше
      if (value && index < inputs.length - 1) {
        inputs[index + 1].focus()
      }

      // 👉 если всё заполнено — auto submit
      const code = inputs.map(i => i.value).join("")

      // Автоматическая отправка отключена.
      // Пользователь подтверждает код только кнопкой.

      if (value) {
          input.classList.add("filled")
        } else {
          input.classList.remove("filled")
        }
     }

    private handleOtpKeyDown = (e: KeyboardEvent) => {

      const input = e.target as HTMLInputElement
      if (!input.classList.contains("otp")) return

      const index = Number(input.dataset.i)

      const inputs = Array.from(
        this.root.querySelectorAll<HTMLInputElement>(".otp")
      )

      // 👉 backspace на пустом → назад
      if (e.key === "Backspace" && !input.value && index > 0) {
        inputs[index - 1].focus()
      }
    }

    private handleOtpPaste = (e: ClipboardEvent) => {

        const input = e.target as HTMLInputElement
        if (!input.classList.contains("otp")) return

        e.preventDefault()

        const paste = e.clipboardData?.getData("text") ?? ""
        const digits = paste.replace(/\D/g, "").slice(0, 4)

        if (!digits) return

        const inputs = Array.from(
          this.root.querySelectorAll<HTMLInputElement>(".otp")
        )

        digits.split("").forEach((char, i) => {
          if (inputs[i]) inputs[i].value = char
        })

        // фокус на последний
        const lastIndex = Math.min(digits.length - 1, inputs.length - 1)
        inputs[lastIndex]?.focus()

        // auto-submit
        // Автоматическая отправка отключена.
        // После вставки пользователь нажимает кнопку "Підтвердити".
      }


  private toggleReveal(taskIndex: number) {
    const state = this.store.getState()
    const isRevealed = state.revealed[taskIndex]

    this.store.update(prev => {
      if (isRevealed) {
        const { [taskIndex]: _, ...restRevealed } = prev.revealed
        const { [taskIndex]: __, ...restGaps } = prev.gaps
        return { ...prev, revealed: restRevealed, gaps: restGaps }
      }

      return {
        ...prev,
        revealed: { ...prev.revealed, [taskIndex]: true }
      }
    })
  }

  // =========================
  // RENDER
  // =========================

render(state: AppState): void {

  const currentKrokId = state.currentKrokId ?? null
  const shouldScroll = currentKrokId && currentKrokId !== this.lastKrokId
  this.lastKrokId = currentKrokId

  this.root.innerHTML = ""

  const app = document.createElement("div")
  app.className = "app"

  switch (state.primaryScreen.type) {

    // 🔵 НОВЫЕ ЭКРАНЫ (НЕ ТРОГАЕМ)

    case "boot":
      app.textContent = "Loading..."
      break

    case "auth":
      app.appendChild(this.renderAuth())
      break

    case "subscribeAuth":
      app.appendChild(this.renderSubscribeAuth())
      break

    case "otp":
      app.appendChild(this.renderOtp(state))
      break  

    case "subscriptions":
      app.appendChild(this.renderAccountHeader())
      app.appendChild(this.renderSubscriptions(state))
      break

    case "confirmChange":
      app.appendChild(this.renderAccountHeader())
      app.appendChild(this.renderConfirmChange(state))
      break


    // 🟢 CORE FLOW (ВОССТАНАВЛИВАЕМ)

    case "core":

      app.appendChild(this.renderHeader(state))
      app.appendChild(this.renderCore(state))
      app.appendChild(this.renderBottomArrows(state))

      break

    case "completion":

      app.appendChild(this.renderHeader(state))
      app.appendChild(this.renderCompletion(state))

      break

    case "menu":

      app.appendChild(this.renderMenu())

      break

    case "repeatList":

      app.appendChild(this.renderRepeat(state))

      break

    case "list":

      app.appendChild(this.renderListHeader())
      app.appendChild(this.renderList(state))

      break

    default:
      app.textContent = "Screen error"
      break

    case "account":

      app.appendChild(this.renderAccountHeader())
      app.appendChild(this.renderAccount(state))

      break

    case "confirmCancelSubscription":

      app.appendChild(this.renderAccountHeader())

      app.appendChild(
        this.renderConfirmCancelSubscription(state)
      )

      break      

    case "notice":
      app.appendChild(this.renderHeader(state))
      app.appendChild(this.renderNotice(state))
      break
  }

  this.root.appendChild(app)
  
    // =========================
    // SCROLL LOGIC
    // =========================

    if (shouldScroll) {

      // 👉 новый крок → вверх
      window.scrollTo({
        top: 0,
        behavior: "instant"
      })

    } else if (state.scrollY) {

      // 👉 reload → восстановление
      window.scrollTo({
        top: state.scrollY,
        behavior: "instant"
      })
    }

}

  // =========================
  // AUTH
  // =========================

     private renderAuth(): HTMLElement {

        const wrapper = document.createElement("div")
        wrapper.className = "auth-container"

        wrapper.innerHTML = `
          <div class="auth-card">

            <a href="https://fr.bezbolu.pro">
              <img src="/icons/logo.png" class="auth-logo">
            </a>

            <div class="auth-welcome">
              Вітаємо вас на платформі для вивчення французької для українців.
              <br/>
              <b>Що ви хочете зробити?</b>
            </div>

            <a 
              class="subscribe-button"
              href="https://fr.bezbolu.pro/#pricing"
            >
              Хочу підписатися
            </a>

            <div class="auth-login-card">

            <div class="auth-login-title">
              Вже підписані?
            </div>

            <input 
              id="auth-email"
              type="email"
              placeholder="Введіть email, на який ви зареєструвалися"
            />

            <button data-action="auth-submit">
              Увійти
            </button>

            <div id="auth-error" class="auth-error"></div>

          </div>

          </div>
        `

        return wrapper
      }

  private renderSubscribeAuth(): HTMLElement {

    const wrapper = document.createElement("div")
    wrapper.className = "auth-container"

    wrapper.innerHTML = `
      <div class="auth-card">

        <a href="https://fr.bezbolu.pro">
          <img src="/icons/logo.png" class="auth-logo">
        </a>

        <div class="auth-welcome">
          Щоб оформити підписку, введіть email
        </div>

        <input 
          id="auth-email"
          type="email"
          placeholder="Email"
        />
        <div class="auth-welcome">
          Вам треба підтвердити email. Натиснить на кнопку нижче, щоб отримати код підтвердження на email.
        </div>

        <button data-action="auth-submit">
          Отримати код
        </button>

        <div id="auth-error" class="auth-error"></div>

      </div>
    `

    return wrapper
  }

  private renderOtp(state: AppState): HTMLElement {

    const wrapper = document.createElement("div")
    wrapper.className = "auth-container"

    const email = (state.primaryScreen as any).email ?? ""

    wrapper.innerHTML = `
      <div class="auth-card">

        <img src="/icons/logo.png" class="auth-logo">

        <div class="auth-welcome">
          Ми надіслали код на<br/>
          <b>${email}</b><br>
          Не бачите лист?
          - Перевірте папку "СПАМ",<br> а також інші папки. 
          </div>

        <div class="otp-inputs">
          <input class="otp" data-i="0" maxlength="1" inputmode="numeric" />
          <input class="otp" data-i="1" maxlength="1" inputmode="numeric" />
          <input class="otp" data-i="2" maxlength="1" inputmode="numeric" />
          <input class="otp" data-i="3" maxlength="1" inputmode="numeric" />
   
        </div>

        <button data-action="otp-submit">
          Підтвердити
        </button>

        <div style="margin-top: 16px;">
            <button 
              data-action="otp-resend"
              id="otp-resend-btn"
            >
              Надіслати код ще раз
            </button>
          </div>

        <div id="otp-error" class="auth-error"></div>

      </div>
    `

    return wrapper
    setTimeout(() => {
      const first = wrapper.querySelector<HTMLInputElement>(".otp")
      first?.focus()
    }, 0)
  }

  // =========================
  // SUBSCRIPTIONS
  // =========================

  private renderSubscriptions(state: AppState): HTMLElement {

    const wrapper = document.createElement("div")
    wrapper.className = "account-screen"

    wrapper.style.paddingTop = "70px"

    if (state.productTitle) {

        const title = document.createElement("h2")

        title.textContent = state.productTitle

        title.style.marginBottom = "20px"

        wrapper.appendChild(title)
      }

    // =========================
    // CURRENT SUBSCRIPTION CARD
    // =========================

    if (state.currentSticker) {

      const currentCard = document.createElement("div")
      currentCard.className = "sticker-card account-card"

      currentCard.innerHTML = `
        <h3>Ваша підписка</h3>

        <p><b>${state.currentSticker.title}</b></p>

        <div class="description">
          ${state.currentSticker.description}
        </div>
      `

      wrapper.appendChild(currentCard)
    }

    // =========================
    // CHANGE TITLE
    // =========================

    if (state.currentSticker && state.stickers.length > 0) {

      const title = document.createElement("h2")
      title.textContent = "Змінити на:"
      title.style.margin = "20px 0 10px 0"

      wrapper.appendChild(title)

      // =========================
      // INFO BLOCK
      // =========================

      const remainingDays =
        state.accountData?.current_subscription?.remaining_days ?? 0

      const info = document.createElement("div")
      info.className = "subscription-info"

      info.innerHTML = `
        
        <p>(Увага! Після зміни підписки стара підписка більше подовжуватися не буде.</p>
        <p>Нова підписка вступає в дію з моменту оплати</p>

        <p>У вас залишилося днів до наступного платежу за старою підпискою: <b>${remainingDays}</b> </p>
        <p>Протягом цього періоду вам будуть ще нараховуватися додаткові Кроки за старою підпискою.)</p>
      `

      info.style.marginBottom = "20px"
      info.style.lineHeight = "1.6"
      info.style.color = "#444"

      wrapper.appendChild(info)
    }
    // =========================
    // GRID
    // =========================

    const grid = document.createElement("div")
    grid.className = "subscriptions-grid"

    if (state.isLoading) {
      grid.textContent = "Завантаження..."
    }
    else if (!state.stickers || state.stickers.length === 0) {
      grid.textContent = "Немає інших доступних підписок"
    }
    else {
      state.stickers.forEach(sticker => {
        grid.appendChild(
          this.renderSticker(
            sticker,
            state.currentSticker !== null
          )
        )
      })
    }

    wrapper.appendChild(grid)

    return wrapper
  }

    private renderSticker(
        sticker: Sticker,
        isChangeFlow: boolean
      ): HTMLElement {

      const action = isChangeFlow
        ? "confirm-change"
        : "subscribe"

    const card = document.createElement("div")
    card.className = "sticker-card"

    card.innerHTML = `
      <h3>${sticker.title}</h3>

      <div class="description">
        ${sticker.description}
      </div>

      <button
          data-action="${action}"
          data-id="${sticker.sticker_id}"
          data-currency="UAH"
        >
        ${sticker.payment_description}

        <div>
          <span class="old-price-uah">
            ${sticker.full_price_uah}
          </span>

          <span class="new-price">
            ${sticker.discounted_price_uah} Грн.
          </span>
        </div>
      </button>
    `

    return card
  }


  // =========================
  // HEADER
  // =========================

    private renderHeader(state: AppState): HTMLElement {
      const header = document.createElement("div")
      header.className = "header"

      // ===== LEFT (List)
      const left = document.createElement("div")
      left.className = "header-left"

      const listBtn = document.createElement("button")
      listBtn.className = "icon-btn"
      listBtn.dataset.action = "list"

      const listIcon = document.createElement("img")
      listIcon.src = "/img/List.png"
      listIcon.alt = "menu"

      listBtn.appendChild(listIcon)
      left.appendChild(listBtn)

      // ===== CENTER (logo + title)
      const center = document.createElement("div")
      center.className = "header-center"

      const logo = document.createElement("img")
      logo.src = "/img/logo.png"
      logo.className = "header-logo"

      center.appendChild(logo)

      // ===== RIGHT (User)
      const right = document.createElement("div")
      right.className = "header-right"

      const userBtn = document.createElement("button")
      userBtn.className = "icon-btn"
      userBtn.dataset.action = "user" // заглушка

      const userIcon = document.createElement("img")
      userIcon.src = "/img/User.png"
      userIcon.alt = "user"

      userBtn.appendChild(userIcon)
      right.appendChild(userBtn)

      // ===== ASSEMBLE
      header.appendChild(left)
      header.appendChild(center)
      header.appendChild(right)

      return header
    }

// =========================
// LIST HEADER
// =========================

    private renderListHeader(): HTMLElement {

      const header = document.createElement("div")
      header.className = "header"

      // ===== LEFT (Back)
      const left = document.createElement("div")
      left.className = "header-left"

      const backBtn = document.createElement("button")
      backBtn.className = "icon-btn"
      backBtn.dataset.action = "back"

      const backIcon = document.createElement("img")
      backIcon.src = "/img/back.png"
      backIcon.alt = "back"

      backBtn.appendChild(backIcon)
      left.appendChild(backBtn)

      // ===== CENTER (logo + title)
      const center = document.createElement("div")
      center.className = "header-center"

      const logo = document.createElement("img")
      logo.src = "/img/logo.png"
      logo.className = "header-logo"

      center.appendChild(logo)

      // ===== RIGHT (User)
      const right = document.createElement("div")
      right.className = "header-right"

      const userBtn = document.createElement("button")
      userBtn.className = "icon-btn"
      userBtn.dataset.action = "user"

      const userIcon = document.createElement("img")
      userIcon.src = "/img/User.png"
      userIcon.alt = "user"

      userBtn.appendChild(userIcon)
      right.appendChild(userBtn)

      // ===== ASSEMBLE
      header.appendChild(left)
      header.appendChild(center)
      header.appendChild(right)

      return header
    }
  // =========================
  // CORE + TASKS
  // =========================
    private renderCore(state: AppState): HTMLElement {
      const content = document.createElement("div")
      content.className = "content"

      if (!state.krok) {
          content.textContent = "Loading..."
          return content
        }

        // =========================
        // KROK HEADER CARD
        // =========================

        const krokHeader = document.createElement("div")
        krokHeader.className = "task krok-header-card"

        krokHeader.innerHTML = `
          <div class="krok-header-product">
            ${(state.krok as any)?.product_title ?? ""}
          </div>

          <div class="krok-header-lesson">
            ${(state.krok as any)?.lesson_title ?? ""}
          </div>

          <div class="krok-header-title">
            ${state.krok.title ?? ""}
          </div>
        `

        content.appendChild(krokHeader)

        // =========================
        // TASKS
        // =========================

        state.krok.tasks.forEach((task, index) => {
          content.appendChild(this.renderTask(task, index, state))
        })

      const btn = document.createElement("button")
      btn.textContent = "Завершити Крок"
      btn.dataset.action = "complete"
      content.appendChild(btn)

      return content
    }

    private renderTask(task: Task, taskIndex: number, state: AppState): HTMLElement {
      switch (task.type) {

        case "explanation": {
          const div = document.createElement("div")
          div.className = "task explanation-task"
          div.innerHTML = task.html
          return div
        }

        case "image": {

          const wrap = document.createElement("div")
          wrap.className = "task image-task"

          const img = document.createElement("img")

          img.src = task.src
          img.alt = task.alt

          img.style.cursor = "pointer"

          img.addEventListener("click", () => {
            this.openImageViewer(task.src)
          })

          wrap.appendChild(img)

          return wrap
        }

        case "audio": {
          const wrap = document.createElement("div")
          wrap.className = "task audio-task"

          const audio = document.createElement("audio")
          audio.src = task.src
          audio.controls = true

          wrap.appendChild(audio)

          return wrap
        }

        case "video": {

          const wrap = document.createElement("div")
          wrap.className = "task video-task"

          const video = document.createElement("video")

          video.src = task.url
          video.controls = true

          wrap.appendChild(video)

          return wrap
        }

        case "gap":
        case "keys":
          return this.renderGap(task, taskIndex, state)
      }
    }


      private renderGap(task: any, taskIndex: number, state: AppState): HTMLElement {

        const wrapper = document.createElement("div")

        wrapper.className =
          task.type === "keys"
            ? "task keys-task card"
            : "task gap-task card"

      const isRevealed = !!state.revealed[taskIndex]

      // ✅ HTML как есть
      wrapper.innerHTML = task.html

      const gapNodes = wrapper.querySelectorAll(".krok-gap")

      gapNodes.forEach((node) => {

        const el = node as HTMLElement
        const id = Number(el.dataset.gapId)
        const gap = task.gaps[id]

        if (!gap) return

        const wrap = document.createElement("span")
        wrap.className = "gap-wrap"

        if (
              task.type !== "keys" &&
              gap.length > 0
            ) {

          const input = document.createElement("input")
          input.type = "text"
          input.className = "gap-input"
          input.style.width = `${Math.max(gap.length * 1.3, 2)}ch`

          input.dataset.gap = "1"
          input.dataset.taskIndex = String(taskIndex)
          input.dataset.segmentIndex = String(id)

          input.value = state.gaps[taskIndex]?.[id] ?? ""

          if (isRevealed) {
            input.disabled = true
          }

          wrap.appendChild(input)
        }

        // ✅ показываем правильный ответ
        if (isRevealed) {
          const answer = document.createElement("span")
          answer.className = "gap-answer"
          answer.textContent = gap.value

          wrap.appendChild(answer)
        }

        el.replaceWith(wrap)
      })

      // =========================
      // КНОПКА
      // =========================

      const btn = document.createElement("button")
      btn.className = "gap-btn"
      btn.dataset.action = "reveal"
      btn.dataset.taskIndex = String(taskIndex)

      btn.textContent = isRevealed
        ? "Зробити ще раз"
        : "Відповідь"

      wrapper.appendChild(btn)

      return wrapper
    }

    private openImageViewer(src: string): void {

      const overlay = document.createElement("div")
      overlay.className = "image-viewer-overlay"

      const container = document.createElement("div")
      container.className = "image-viewer-container"

      const img = document.createElement("img")
      img.src = src
      img.className = "image-viewer-image"

      const closeBtn = document.createElement("button")
      closeBtn.className = "image-viewer-close"
      closeBtn.textContent = "✕"

      container.appendChild(img)
      container.appendChild(closeBtn)

      overlay.appendChild(container)

      const close = () => {

        document.removeEventListener(
          "keydown",
          handleKeyDown
        )

        overlay.remove()
      }

      const handleKeyDown = (e: KeyboardEvent) => {

        if (e.key === "Escape") {
          close()
        }
      }

      overlay.addEventListener("click", close)

      container.addEventListener("click", (e) => {
          e.stopPropagation()
        })

        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation()
          close()
        })

      document.addEventListener(
        "keydown",
        handleKeyDown
      )

      document.body.appendChild(overlay)
    }

  // =========================
  // OTHER
  // =========================

    private renderAccountHeader(): HTMLElement {

        const header = document.createElement("div")
        header.className = "header"

        // LEFT (back)
        const left = document.createElement("div")
        left.className = "header-left"

        const backBtn = document.createElement("button")
        backBtn.className = "icon-btn"
        backBtn.dataset.action = "back"

        const backIcon = document.createElement("img")
        backIcon.src = "/img/back.png"

        backBtn.appendChild(backIcon)
        left.appendChild(backBtn)

        // CENTER
        const center = document.createElement("div")
        center.className = "header-center"

        const logo = document.createElement("img")
        logo.src = "/img/logo.png"
        logo.className = "header-logo"

        const title = document.createElement("div") // ✅ ВОТ ЭТОГО НЕ ХВАТАЛО
        title.className = "header-title account-email-title"

        const email = this.store.getState().accountData?.email ?? ""
        title.textContent = email

        center.appendChild(logo)
        center.appendChild(title)

        // RIGHT (logout)
        const right = document.createElement("div")
        right.className = "header-right"

        const logoutBtn = document.createElement("button")
        logoutBtn.className = "logout-button"
        logoutBtn.dataset.action = "logout"
        logoutBtn.textContent = "Вийти"

        right.appendChild(logoutBtn)

        header.appendChild(left)
        header.appendChild(center)
        header.appendChild(right)

        return header
      }

    private renderAccount(state: AppState): HTMLElement {

      const wrapper = document.createElement("div")
      wrapper.className = "account-screen"

      wrapper.style.paddingTop = "70px"

      if (state.isAccountLoading) {
        wrapper.textContent = "Завантаження..."
        return wrapper
      }

      const data = state.accountData

      if (!data) {
        wrapper.textContent = "Немає даних"
        return wrapper
      }

      const titleCard = document.createElement("div")
      titleCard.className = "sticker-card account-card account-title"

      titleCard.innerHTML = `
        <h3>Ваш акаунт</h3>
      `
      
      wrapper.appendChild(titleCard)

      data.products.forEach(product => {

        const card = document.createElement("div")

        card.className = "sticker-card account-card"

        let html = `
          <h3>${product.title}</h3>
        `

        // =====================================================
        // ACTIVE
        // =====================================================

        if (product.state === "active") {

          html += `
            <p>
              Залишок доступних нових кроків на зараз:
              <b>${product.remaining_new_kroks}</b>
            </p>
          `
          if (product.continue_krok_id) {

              html += `
                <div class="account-actions">

                  <button
                    class="primary-wide"
                    data-action="open-krok-from-list"
                    data-id="${product.continue_krok_id}"
                  >
                    До навчання
                  </button>

                </div>
              `
            }

        product.subscriptions.forEach(sub => {

          const subscriptionTitle =
            sub.renewal_active
              ? "Поточна підписка"
              : "Попередня підписка"

          html += `
            <div class="account-sub-block">

              <h4>${subscriptionTitle}</h4>

             <p>
              Кількість кроків:
              <b>${sub.cycle_krok_limit}</b>
              на
              <b>${sub.cycle_days}</b>
              дн.
            </p>

              <p>
                Залишилось днів:
                <b>${sub.remaining_days}</b>
              </p>
          `

          if (sub.renewal_active) {

            html += `
              <p>
                Автопродовження увімкнено
              </p>

              <p>
                Наступна оплата:
                <b>${sub.next_payment_date}</b>
              </p>

              <div class="account-actions">

                <button
                  class="cancel-subscription-btn"
                  data-action="cancel-subscription"
                  data-subscription-id="${sub.subscription_id}"
                >
                  Скасувати автопродовження
                </button>

              </div>
            `

          } else {

            html += `
              <p>
                Автопродовження вимкнено
              </p>
            `
          }

          html += `
            </div>
          `
        })

        const hasRenewalSubscription =
          product.subscriptions.some(
            s => s.renewal_active
          )

        if (hasRenewalSubscription) {

          if (product.can_change_subscription) {

            html += `
              <div class="account-actions">

                <button
                  class="primary-wide"
                  data-action="open-subscriptions"
                  data-product-id="${product.product_id}"
                >
                  Змінити підписку
                </button>

              </div>
            `
          }

        } else {

          html += `
            <div class="account-actions">

              <button
                class="primary-wide"
                data-action="open-subscriptions"
                data-product-id="${product.product_id}"
              >
                Оформити підписку
              </button>

            </div>
          `
        }
        
        if (product.landing_url) {

            html += `
              <div class="account-actions">

                <button
                  class="secondary-button"
                  data-action="copy-landing-link"
                  data-title="${product.title}"
                  data-url="${product.landing_url}"
                >
                  Відправити посилання другу
                </button>

              </div>
            `
          }
        }

        // =====================================================
        // RECOVERABLE
        // =====================================================

        if (product.state === "recoverable") {

          html += `
            <p>
              Підписка завершилась
            </p>

            <div class="account-actions">

              <button
                class="primary-wide"
                data-action="open-subscriptions"
                data-product-id="${product.product_id}"
              >
                Оформити підписку
              </button>

            </div>
          `
          if (product.continue_krok_id) {

            html += `
              <div class="account-actions">

                <button
                  class="primary-wide"
                  data-action="open-krok-from-list"
                  data-id="${product.continue_krok_id}"
                >
                  До кроків, що залишилися
                </button>

              </div>
            `
          }

            if (product.landing_url) {

              html += `
                <div class="account-actions">

                  <button
                    class="secondary-button"
                    data-action="copy-landing-link"
                    data-title="${product.title}"
                    data-url="${product.landing_url}"
                  >
                    Відправити посилання другу
                  </button>

                </div>
              `
            }


        }

        // =====================================================
        // NEVER_SUBSCRIBED
        // =====================================================

        if (product.state === "never_subscribed") {

          html += `
            <p>
              Ви не маєте діючої підписки
            </p>

            <div class="account-actions">

              <button
                class="primary-wide"
                data-action="open-subscriptions"
                data-product-id="${product.product_id}"
              >
                Оформити підписку
              </button>

            </div>
          `
      
            if (product.landing_url) {

              html += `
                <div class="account-actions">

                  <button
                    class="primary-wide"
                    data-action="open-landing"
                    data-url="${product.landing_url}"
                  >
                    Детальніше
                  </button>

                </div>
              `
            }


        }

        card.innerHTML = html

        wrapper.appendChild(card)

      })

      return wrapper
    } 
     
    private renderCompletion(state: AppState): HTMLElement {
      const wrapper = document.createElement("div")
      wrapper.className = "completion-screen"

      if (state.primaryScreen.type !== "completion") return wrapper

      const msg = document.createElement("h2")

      if (state.primaryScreen.nextState === "available") {
        msg.textContent = "Чудово, черговий крок пройдено"
        wrapper.appendChild(msg)

        const btn = document.createElement("button")
        btn.textContent = "Продовжити навчання"
        btn.dataset.action = "continue"
        wrapper.appendChild(btn)
      }

      if (state.primaryScreen.nextState === "locked") {
        msg.textContent =
          "Чудово, черговий крок пройдено. Чекаємо на вас завтра"
        wrapper.appendChild(msg)
      }

      if (state.primaryScreen.nextState === "finished") {
        msg.textContent = "Вітаємо, цей курс пройдено"
        wrapper.appendChild(msg)

        const btn = document.createElement("button")
        btn.textContent = "Підписатися на наступний курс"
        btn.dataset.action = "subscribe"
        wrapper.appendChild(btn)
      }

      return wrapper
    }

    private renderNotice(state: AppState): HTMLElement {

      if (state.primaryScreen.type !== "notice") {
        return document.createElement("div")
      }

      const {
          noticeType,
          notice,
          nextKrokId,
          continueProducts
        } = state.primaryScreen

      const data = notice?.[0] ?? null

      const wrapper = document.createElement("div")
      wrapper.className = "content"

      // =========================
      // BLOCK 1
      // =========================

      const block1 = document.createElement("div")
      block1.className = "task explanation-task notice-center"

      const text = document.createElement("p")
      text.style.textAlign = "center"

      // ===== next_available =====
      if (noticeType === "next_available") {

        text.innerHTML = "<b>Чудово!</b> Ви завершили цей Крок."

        const btn = document.createElement("button")
        btn.textContent = "Перейти до наступного Кроку"
        btn.dataset.action = "go-next-from-notice"
        btn.dataset.id = nextKrokId ?? ""

        btn.style.display = "block"
        btn.style.margin = "24px auto 0 auto"

        block1.appendChild(text)
        block1.appendChild(btn)
      }

      // ===== locked =====
      else if (noticeType === "locked") {

        text.innerHTML = "Чудово! Ви вже пройшли всі доступні вам на сьогодні кроки. Новий крок відкриється завтра."

        block1.appendChild(text)
      }

      // ===== finished =====
      else if (noticeType === "finished") {

        text.innerHTML = "Вітаємо! Ви успішно завершили цей курс."

        block1.appendChild(text)
      }

      wrapper.appendChild(block1)

      // =========================
      // OTHER PRODUCTS
      // =========================

      if (continueProducts.length > 0) {

        const productsBlock = document.createElement("div")
        productsBlock.className = "task explanation-task"

        const title = document.createElement("h3")
        title.textContent = "Інші ваші курси"

        productsBlock.appendChild(title)

        continueProducts.forEach(product => {

          const card = document.createElement("div")

          card.style.marginTop = "16px"
          card.style.paddingTop = "12px"
          card.style.borderTop = "1px solid #ddd"

          const productTitle = document.createElement("div")
          productTitle.innerHTML = `<b>${product.title}</b>`

          card.appendChild(productTitle)

          if (product.noticeType === "continue_next") {

            const btn = document.createElement("button")

            btn.textContent = "Перейти"

            btn.dataset.action = "go-next-from-notice"

            btn.dataset.id = product.nextKrokId ?? ""

            btn.style.marginTop = "10px"

            card.appendChild(btn)

          } else {

            const text = document.createElement("div")

            text.textContent =
              "Доступних нових кроків немає"

            text.style.marginTop = "10px"

            card.appendChild(text)
          }

          productsBlock.appendChild(card)
        })

        wrapper.appendChild(productsBlock)
      }

      // =========================
      // BLOCK 2 (title)
      // =========================

      if (data?.title) {

        const block2 = document.createElement("div")
        block2.className = "task explanation-task"

        block2.innerHTML = `
          <p>
            Читайте / Дивіться важливе лексичне доповнення до цього кроку:
          </p>
          <b>${data.title}</b>
        `

        wrapper.appendChild(block2)
      }

      // =========================
      // GRID (BLOCK 4 + 5)
      // =========================

      if (data?.links) {

        const grid = document.createElement("div")
        grid.className = "notice-grid"

        const allItems: Array<{ url: string; icon: string }> = []

        // собираем все ссылки в один список
        Object.entries(data.links.video || {}).forEach(([platform, item]: any) => {
          allItems.push({ ...item, platform })
        })

        Object.entries(data.links.text || {}).forEach(([platform, item]: any) => {
          allItems.push({ ...item, platform })
        })

        // если нет ничего — не рендерим
        if (allItems.length === 0) {
          return wrapper
        }

        allItems.forEach(item => {

          const card = document.createElement("a")
          card.href = item.url
          card.target = "_blank"
          card.className = `notice-card notice-${item.platform}`

      card.innerHTML = `
        <img src="${item.icon}" class="notice-card-img" />
      `

      // 🔥 BADGE
      if (item.platform) {

        const badge = document.createElement("div")
        badge.className = "notice-badge"

        const icon = document.createElement("img")

        if (item.platform === "instagram") {
          icon.src = "/icons/instagram.png"
        }

        if (item.platform === "facebook") {
          icon.src = "/icons/facebook.png"
        }

        if (item.platform === "youtube") {
          icon.src = "/icons/youtube.png"
        }

        if (item.platform === "tiktok") {
          icon.src = "/icons/tiktok.png"
        }

        icon.className = "notice-badge-icon"

        badge.appendChild(icon)
        card.appendChild(badge)
      }

          grid.appendChild(card)
        })

        wrapper.appendChild(grid)

        // центр если одна карточка
        if (allItems.length === 1) {
          grid.style.display = "flex"
          grid.style.justifyContent = "center"
        }
      }
      return wrapper
    }

    private renderConfirmChange(state: AppState): HTMLElement {

      const wrapper = document.createElement("div")
      wrapper.className = "account-screen"

      // ✅ отступ под header (как в account/list)
      wrapper.style.paddingTop = "70px"

      const screen = state.primaryScreen as any
      const data = screen.data

      if (!data) {
        wrapper.textContent = "Немає даних"
        return wrapper
      }

      const card = document.createElement("div")
      card.className = "sticker-card account-card"

      card.innerHTML = `
        <h2>${data.product_title ?? ""}</h2>

        <h3>Підтвердження зміни підписки</h3>

        <p>
          У вас залишилось
          <b>${data.remaining_days}</b>
          днів поточної підписки.
        </p>

        <p>
          Ви впевнені, що хочете змінити підписку?
        </p>
      `

      const actions = document.createElement("div")
      actions.className = "account-actions"

      actions.innerHTML = `
        <button class="primary-wide" data-action="confirm-subscription-change">
          Підтвердити
        </button>

        <button class="primary-wide cancel-btn" data-action="back">
          Скасувати зміну підписки
        </button>
      `

      card.appendChild(actions)
      wrapper.appendChild(card)

      return wrapper
    }

    private renderConfirmCancelSubscription(
        state: AppState
      ): HTMLElement {

        const wrapper = document.createElement("div")

        wrapper.className = "account-screen"

        wrapper.style.paddingTop = "70px"

        const selectedSubscriptionId =
          state.selectedSubscriptionId

        let sub: any = null

        for (const product of state.accountData?.products ?? []) {

          const found =
            product.subscriptions.find(
              s =>
                s.subscription_id ===
                selectedSubscriptionId
            )

          if (found) {
            sub = found
            break
          }
        }

        if (!sub) {

          wrapper.textContent =
            "Підписку не знайдено"

          return wrapper
        }

        const card = document.createElement("div")

        card.className = "sticker-card account-card"

        card.innerHTML = `
          <h3>
            Підтвердження відміни автоматичного продовження підписки
          </h3>

          <p>
              Кількість кроків:
              <b>${sub.cycle_krok_limit}</b>
              на
              <b>${sub.cycle_days}</b>
              дн.
            </p>

          <p>
            Автоматичне продовження через
            <b>${sub.remaining_days}</b>
            днів
          </p>

          <p>
            Наступна оплата:
            <b>${sub.next_payment_date}</b>
          </p>

          <br>

          <p>
            Ви впевнені, що хочете відмінити
            автоматичне продовження підписки?
          </p>
        `

        const actions = document.createElement("div")

        actions.className = "account-actions"

        actions.innerHTML = `
          <button
            class="primary-wide"
            data-action="confirm-cancel-subscription"
          >
            Підтвердити
          </button>

          <button
            class="primary-wide cancel-btn"
            data-action="back"
          >
            Ні, повернутись до навчання
          </button>
        `

        card.appendChild(actions)

        wrapper.appendChild(card)

        return wrapper
      }

    private renderMenu(): HTMLElement {
      const wrapper = document.createElement("div")
      wrapper.className = "menu-screen"

      wrapper.innerHTML = `
        <button data-action="back">◄</button>
        <button>Мій Аккаунт</button>
        <button data-action="open-repeat">Пройдені кроки</button>
        <button data-action="return-current">Повернутися до навчання</button>
        <button data-action="back">◄ Назад</button>
      `

      return wrapper
    }

    private renderRepeat(state: AppState): HTMLElement {
      const wrapper = document.createElement("div")
      wrapper.className = "repeat-screen"



      if (!state.repeatItems) {
        wrapper.appendChild(document.createTextNode("Loading..."))
        return wrapper
      }

      const grouped = this.groupByLesson(state.repeatItems)

      Object.values(grouped).forEach((lesson: any) => {

        const header = document.createElement("div")

        const toggle = document.createElement("button")
        toggle.textContent =
          state.expandedLessons[lesson.lesson_id] ? "−" : "+"
        toggle.dataset.action = "toggle-lesson"
        toggle.dataset.id = lesson.lesson_id

        const title = document.createElement("span")
        title.textContent = lesson.lesson_title

        header.appendChild(toggle)
        header.appendChild(title)
        wrapper.appendChild(header)

        if (state.expandedLessons[lesson.lesson_id]) {
          lesson.kroks.forEach((k: any) => {
            const btn = document.createElement("button")
            btn.textContent = k.krok_title
            btn.dataset.action = "open-krok"
            btn.dataset.id = k.krok_id
            wrapper.appendChild(btn)
          })
        }
      })

      return wrapper
    }

    private renderList(state: AppState): HTMLElement {

      const wrapper = document.createElement("div")
      wrapper.className = "list-screen"

      wrapper.style.paddingTop = "70px"

      // =========================
      // LOADING
      // =========================

      if (state.isListLoading) {
        wrapper.appendChild(
          document.createTextNode("Завантаження...")
        )
        return wrapper
      }

      // =========================
      // NO DATA
      // =========================

      if (!state.completedProducts) {
        wrapper.appendChild(
          document.createTextNode("Немає даних")
        )
        return wrapper
      }

      // =========================
      // EMPTY
      // =========================

      if (state.completedProducts.length === 0) {



        const card = document.createElement("div")
        card.className =
          "sticker-card account-card empty-state"

        card.innerHTML = `
          <div class="empty-text">
            Тут відображається перелік кроків, які ви пройшли.<br/><br/>
            Наразі ви не маєте пройдених кроків.
          </div>
        `

        wrapper.appendChild(card)

        return wrapper
      }

      // =========================
      // TITLE CARD
      // =========================

      const titleCard =
        document.createElement("div")

      titleCard.className =
        "sticker-card account-card list-title-card"

      titleCard.innerHTML = `
        <h2>
          Перелік пройдених та доступних кроків
        </h2>
      `

      wrapper.appendChild(titleCard)

      // =========================
      // PRODUCTS
      // =========================

      state.completedProducts.forEach(product => {

        // -------------------------
        // PRODUCT CARD
        // -------------------------

        const productCard = document.createElement("div")

        productCard.className =
          "sticker-card account-card list-product-card"

        productCard.innerHTML = `
          <h3>${product.product_title}</h3>
        `

        
        // -------------------------
        // LESSONS
        // -------------------------

        product.lessons.forEach(lesson => {

          const lessonBlock =
            document.createElement("div")

          lessonBlock.className =
            "lesson-block"

          const header =
            document.createElement("div")

          header.className =
            "lesson-header"

          const toggle =
            document.createElement("button")

          toggle.className =
            "lesson-toggle"

          toggle.dataset.action =
            "toggle-lesson"

          toggle.dataset.id =
            lesson.lesson_id

          const isOpen =
            state.expandedLessons[
              lesson.lesson_id
            ]

          toggle.textContent =
            isOpen ? "−" : "+"

          const title =
            document.createElement("span")

          title.className =
            "lesson-title"

          title.textContent =
            lesson.lesson_title

          header.appendChild(toggle)
          header.appendChild(title)

          lessonBlock.appendChild(header)

          // =========================
          // KROKS
          // =========================

          if (isOpen) {

          lesson.kroks.forEach(krok => {

            // =========================
            // ACTIVE KROK
            // =========================

            if (krok.krok_id) {

              const btn =
                document.createElement("button")

            btn.className =
              "krok-btn"

            if (
              krok.krok_title.startsWith(
                "Поточний/Наступний."
              )
            ) {
              btn.classList.add(
                "krok-current"
              )
            }

            btn.textContent =
              krok.krok_title

              btn.dataset.action =
                "open-krok-from-list"

              btn.dataset.id =
                krok.krok_id

              lessonBlock.appendChild(btn)

              return
            }

            // =========================
            // FUTURE AVAILABLE
            // =========================

            const placeholder =
              document.createElement("div")

            placeholder.className =
              "krok-placeholder"

            placeholder.textContent =
              krok.krok_title

            lessonBlock.appendChild(placeholder)
          })
          }

              productCard.appendChild(lessonBlock)
            })
              wrapper.appendChild(productCard)
            
      })

      return wrapper
    }

    private renderBottomArrows(state: AppState): HTMLElement {
      const wrapper = document.createElement("div")
      wrapper.className = "bottom-arrows"

      if (state.primaryScreen.type === "core" && state.krok) {

        const createIcon = (src: string, alt: string) => {
          const img = document.createElement("img")
          img.src = src
          img.alt = alt
          return img
        }

        // ◄ PREV
        if (state.krok.prev_krok_id) {
          const prev = document.createElement("button")
          prev.dataset.action = "prev"
          prev.className = "arrow-btn"

          prev.appendChild(createIcon("/img/prev.png", "prev"))
          wrapper.appendChild(prev)
        } else {
          wrapper.appendChild(document.createElement("div"))
        }

        // ⏩ ENTRY
        if (state.krok.next_krok_id !== null) {
          const entry = document.createElement("button")
          entry.dataset.action = "entry"
          entry.className = "arrow-btn"

          entry.appendChild(createIcon("/img/entry.png", "entry"))
          wrapper.appendChild(entry)
        } else {
          wrapper.appendChild(document.createElement("div"))
        }

        // ► NEXT
        if (state.krok.next_krok_id) {
          const next = document.createElement("button")
          next.dataset.action = "next"
          next.className = "arrow-btn"

          next.appendChild(createIcon("/img/next.png", "next"))
          wrapper.appendChild(next)
        } else {
          wrapper.appendChild(document.createElement("div"))
        }
      }

      return wrapper
    }
}
